import axios from 'axios';

export const TrustScoreDistributionDataSets = {
  WORKSPACE: 'workspace',
  INSCRIBE: 'inscribe',
};

export const state = {
  documentId: undefined,
  list: [],
  loading: false,
  scoreDistribution: {},
};

export const mutations = {
  setLoading(state, loading) {
    state.loading = loading;
  },
  setDocumentId(state, documentId) {
    state.documentId = documentId;
  },
  setSimilarDocumentsList(state, similarDocuments) {
    state.list = similarDocuments;
  },
  setScoreDistribution(state, params) {
    const newObj = {};
    newObj[params.type] = params.data;
    state.scoreDistribution = { ...state.scoreDistribution, ...newObj };
  },
  resetScoreDistribution(state) {
    state.scoreDistribution = {};
  },
};

export const getters = {
  getScoreDistribution: (state) => (type) => {
    return state.scoreDistribution[type] || null;
  },
  dataIsMeaningful(data) {
    return data?.reduce((tot, val) => parseFloat(tot) + parseFloat(val), 0) > 0;
  },
  hasWorskpaceData(state) {
    const typeData =
      state.scoreDistribution[TrustScoreDistributionDataSets.WORKSPACE];
    const dataset = typeData
      ? typeData[TrustScoreDistributionDataSets.WORKSPACE]
      : undefined;
    return dataset && getters.dataIsMeaningful(dataset);
  },
  hasInscribeData(state) {
    const typeData =
      state.scoreDistribution[TrustScoreDistributionDataSets.INSCRIBE];
    const dataset = typeData
      ? typeData[TrustScoreDistributionDataSets.INSCRIBE]
      : undefined;
    return dataset && getters.dataIsMeaningful(dataset);
  },
  shouldDisplayChart() {
    return getters.hasWorskpaceData() || getters.hasInscribeData();
  },
  getSimilarDocumentsList(state) {
    return state.list;
  },
  getSimilarDocumentsCount(state) {
    return state.list?.length || 0;
  },
  getLoading(state) {
    return state.loading;
  },
};

export const actions = {
  loadSimilarDocuments(context, { customerId, documentId }) {
    context.commit('setLoading', true);
    context.commit('setDocumentId', documentId);

    return axios
      .get(`/api/v2/customers/${customerId}/documents/${documentId}/similar/`)
      .then(({ data }) => {
        context.commit('setSimilarDocumentsList', data.data);
        context.commit('setLoading', false);
      });
  },
  loadScoreDistribution(context, { customerId, documentId, type }) {
    context.commit('setLoading', true);
    return axios
      .get(
        `/api/v2/customers/${customerId}/documents/${documentId}/similar/trust_score_distribution?data_context=${type}`,
      )
      .then(({ data }) => {
        context.commit('setScoreDistribution', { data, type });
      })
      .finally(() => {
        context.commit('setLoading', false);
      });
  },
};

export default {
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions,
};
